import { getUserName } from '../helpers/getUserName';
import { createFakeEmployee } from './employee';
import { fakeReferences } from './references';
export const fakeStaffClient = () => {
    const pageSize = 11;
    const employees = [
        createFakeEmployee('1', 'One', 'test@skbkontur.ru'),
        createFakeEmployee('2', 'Two', 'longlonglonglonglonglonglong@skbkontur.ru'),
        createFakeEmployee('3', 'Three'),
        createFakeEmployee('4', 'Four'),
        createFakeEmployee('5', 'Five'),
        createFakeEmployee('6', 'Six', 'test@skbkontur.ru'),
        createFakeEmployee('7', 'Seven', 'longlonglonglonglonglonglong@skbkontur.ru'),
        createFakeEmployee('8', 'Eight'),
        createFakeEmployee('9', 'Nine'),
        createFakeEmployee('10', 'Ten'),
        createFakeEmployee('11', 'Eleven', 'test@skbkontur.ru'),
        createFakeEmployee('12', 'Twelve', 'longlonglonglonglonglonglong@skbkontur.ru'),
        createFakeEmployee('13', 'Thirteen'),
        createFakeEmployee('14', 'Fourteen'),
        createFakeEmployee('15', 'Fifteen'),
        createFakeEmployee('16', 'Sixteen', 'test@skbkontur.ru'),
        createFakeEmployee('17', 'Seventeen', 'longlonglonglonglonglonglong@skbkontur.ru'),
        createFakeEmployee('18', 'Eighteen'),
        createFakeEmployee('19', 'Nineteen'),
        createFakeEmployee('20', 'Twenty'),
    ];
    const fakeMethod = () => {
        throw new Error('NotImplemented');
    };
    return {
        getReferences: async () => {
            return fakeReferences;
        },
        patchEmployees: async () => {
            return Promise.resolve({
                totalCount: 10,
                successfulCount: 9,
                version: 2,
            });
        },
        getReference() {
            return Promise.resolve([]);
        },
        getEmployee: async (employerId, employeeId) => {
            return employees.find(({ id }) => id === employeeId) || employees[0];
        },
        getEmployees: async (employerId, query) => {
            if (employerId === 'empty') {
                return { items: [], totalCount: 0 };
            }
            const { name, skip, ids } = query ?? {};
            if (name === 'error') {
                throw 'fake error';
            }
            if (ids) {
                const returnedEmployees = employees.filter((initialEmployee) => ids.find((employeeId) => initialEmployee.id === employeeId));
                return {
                    items: returnedEmployees,
                    totalCount: returnedEmployees.length - 1,
                };
            }
            const filtered = name ? employees.filter((e) => getUserName(e.profile.name).includes(name)) : employees;
            const paged = skip !== undefined ? filtered.slice(skip, (skip ?? 0) + pageSize) : filtered;
            return { items: paged, totalCount: filtered.length };
        },
        createEmployee: async (employerId, request) => {
            console.log({ employerId, request });
            return { id: '100500' };
        },
        patchEmployee: async (employerId, oldEmployee, newEmployee) => {
            console.log({ employerId, oldEmployee, newEmployee });
            return { version: 100500 };
        },
        getClients: async (employerId, query) => {
            if (employerId === 'empty') {
                return { items: [], totalCount: 0 };
            }
            const { name, skip, ids } = query ?? {};
            if (name === 'error') {
                throw 'fake error';
            }
            if (ids) {
                const returnedEmployees = employees.filter((initialEmployee) => ids.find((employeeId) => initialEmployee.id === employeeId));
                return {
                    items: returnedEmployees,
                    totalCount: returnedEmployees.length - 1,
                };
            }
            const filtered = name ? employees.filter((e) => getUserName(e.profile.name).includes(name)) : employees;
            const paged = skip !== undefined ? filtered.slice(skip, (skip ?? 0) + pageSize) : filtered;
            return { items: paged, totalCount: filtered.length };
        },
        createClient: async () => {
            return { id: '100500' };
        },
        patchClient: async () => {
            return { version: 100500 };
        },
        deleteClient: fakeMethod,
        deleteEmployee: fakeMethod,
        saveEmployee: fakeMethod,
        getWorkingEvents: fakeMethod,
        getWorkingEvent: fakeMethod,
        deleteWorkingEvent: fakeMethod,
        patchWorkingEvent: fakeMethod,
        createWorkingEvent: fakeMethod,
        mergeWorkingEvent: fakeMethod,
        getIdentityDocument: fakeMethod,
        getIdentityDocuments: async () => {
            return {
                totalCount: 0,
                items: [],
            };
        },
        createIdentityDocument: fakeMethod,
        mergeIdentityDocument: fakeMethod,
        deleteIdentityDocument: fakeMethod,
        patchIdentityDocument: fakeMethod,
        getDocuments: fakeMethod,
        getDocumentByTypeOriginId: fakeMethod,
        getDocumentById: fakeMethod,
        createDocument: fakeMethod,
        deleteDocumentByTypeOriginId: fakeMethod,
        deleteDocumentById: fakeMethod,
        getClientsIdentityDocuments: fakeMethod,
        createClientsIdentityDocument: fakeMethod,
        deleteClientsIdentityDocument: fakeMethod,
        patchClientsIdentityDocument: fakeMethod,
        getRelative: fakeMethod,
        deleteRelative: fakeMethod,
        patchRelative: fakeMethod,
        getRelatives: fakeMethod,
        addRelative: fakeMethod,
        mergeRelative: fakeMethod,
        matchEmployee: fakeMethod,
    };
};
